import React, { Component, Fragment } from 'react'
import Equalizer from 'react-equalizer'

class Bricks extends Component {
    renderBricks() {
        const { data, css } = this.props

        return (
            <Fragment>
                <div className={`container ${css}`} >
                    <div className="row text-center">
                        <div className=" text-center" style={{ margin: 'auto' }}>
                            {data.title && <h2 className="text-center lined">{data.title}</h2>}
                        </div>
                    </div>
                    <div className="row">
                        <Equalizer byRow={false}>
                            {
                                data.bricks.map((brick, key) => {
                                    return (
                                        <div key={key} className="col-md-6 brick"
                                            style={{ background: `url(${brick.image}) no-repeat center center` }}
                                        >
                                            <div className="brick-content text-center">
                                                <h3>{brick.title}</h3>
                                                <p dangerouslySetInnerHTML={{ __html: brick.text }} className="text-center"></p>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </Equalizer>
                    </div>
                </div>
            </Fragment>
        )
    }

    render() {
        return (
            <Fragment>
                {this.renderBricks()}
            </Fragment>
        )
    }
}

export { Bricks }


// WEBPACK FOOTER //
// ./src/components/sections/Bricks.js